<template>
  <div>
    <b-modal
      ref="import-product-modal"
      hide-footer
      title="Thêm sản phẩm từ Excel"
      id="modal-prevent-closing"
      size="xl"
    >
      <b-row>
        <b-col>
          <div class="form-group">
            <span>
              <b>Bước 1:</b> Vui lòng chuẩn bị dữ liệu mẫu từ file excel đúng
              format, hoặc có thể tải ở
              <a :href="urlExcel">đây</a>
            </span>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <span> <b>Bước 2:</b> Tiến hành Import </span>
          <div style="padding-top: 15px">
            <b-form-file
              placeholder="Hãy chọn một tập tin"
              @change="selectFile"
              v-model="file"
              ref="file-input"
              class="mb-2"
            ></b-form-file>
          </div>
        </b-col>
      </b-row>
      <b-container class="mt-4 pl-0 pr-0" v-show="importItems.length > 0">
        <h5>
          Danh sách sản phẩm từ file excel( Tổng:
          {{ importItems.length }} sản phẩm)
        </h5>
        <b-table
          id="my-table"
          class="myTable"
          responsive
          bordered
          hover
          :fields="fieldImport"
          :items="importItems"
          :per-page="10"
          :current-page="currentPage"
        >
          <template v-slot:cell(productName)="row">
            <span v-text="row.item.productCode"></span>
            <br />
            <span v-text="row.item.productName"></span>
          </template>

          <template v-slot:cell(unitPrice)="row">
            <div style="text-align: end">
              <span v-text="convertPrice(row.item.unitPrice)"></span>
            </div>
          </template>
          <template v-slot:cell(totalAmount)="row">
            <div style="text-align: end">
              <span v-text="convertPrice(row.item.totalAmount)"></span>
            </div>
          </template>
          <template v-slot:cell(quantity)="row">
            <div style="text-align: end">
              <span v-text="convertPrice(row.item.quantity)"></span>
            </div>
          </template>
          <template v-slot:cell(discountAmount)="row">
            <div style="text-align: end">
              <span v-text="convertPrice(row.item.discountAmount)"></span>
            </div>
          </template>
        </b-table>
        <b-pagination
          v-show="importItems.length > 10"
          v-model="currentPage"
          :total-rows="importItems.length"
          :per-page="10"
          aria-controls="my-table"
        ></b-pagination>
      </b-container>
      <b-button
        style="fontweight: 600; width: 70px"
        variant="primary"
        size="sm"
        @click="validData"
        >Lưu</b-button
      >
      <b-button
        style="margin-left: 10px; font-weight: 600; width: 70px"
        variant="secondary"
        size="sm"
        @click="hideModalImportProduct"
        >Hủy</b-button
      >
    </b-modal>
  </div>
</template>

<style>
.table th,
.table td {
  padding: 0.75rem;
  vertical-align: middle;
  border-top: 1px solid #ecf0f3;
}
.table.b-table.table-sm > thead > tr > [aria-sort]:not(.b-table-sort-icon-left),
.table.b-table.table-sm
  > tfoot
  > tr
  > [aria-sort]:not(.b-table-sort-icon-left) {
  background-position: right calc(1.5rem / 2) center;
  padding-right: calc(0.3rem + 0.65em);
}
</style>

<script>
import {
  makeToastSuccess,
  makeToastFaile,
  convertPrice,
} from '../../../utils/common';
import { URL_IMPORT_STOCKSLIP } from './../../../utils/constants';
import xlsx from 'xlsx';
import ApiService from '@/core/services/api.service';
import { v4 } from 'uuid';

export default {
  props: ['type', 'storeId'],
  data() {
    return {
      importItems: [],
      file: null,
      excellist: [],
      currentPage: 1,
      urlExcel: URL_IMPORT_STOCKSLIP,
      fieldImport: [
        {
          key: 'productName',
          label: 'Sản phẩm',
        },
        {
          key: 'productImei',
          label: 'IMEI',
        },
        {
          key: 'quantity',
          label: 'Số lượng',
        },
        {
          key: 'unitPrice',
          label: 'Đơn giá',
        },
        {
          key: 'discountAmount',
          label: 'Chiết khấu',
        },
        {
          key: 'totalAmount',
          label: 'Thành tiền',
        },
      ],
      listResult: [],
    };
  },
  created() {},
  methods: {
    selectFile(event) {
      this.importItems = [];
      const files = event.target.files[0];
      this.file = files;
      if (!files) {
        return;
      } else if (!/\.(xls|xlsx)$/.test(files.name.toLowerCase())) {
        this.file = null;
        this.clearFiles();
        return alert(
          'Định dạng của file tải lên không chính xác. Vui lòng tải lên file có đuôi .xls hoặc .xlsx'
        );
      }
      const fileReader = new FileReader();
      fileReader.onload = (ev) => {
        try {
          const data = ev.target.result;
          const XLSX = xlsx;
          const workbook = XLSX.read(data, {
            type: 'binary',
          });
          const wsname = workbook.SheetNames[0]; // Take the first sheet，wb.SheetNames[0] :Take the name of the first sheet in the sheets
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname], {
            blankRows: false,
          }); // Generate JSON table content，wb.Sheets Get the data of the first sheet
          const excellist = []; // Clear received data
          // Edit data
          for (var i = 0; i < ws.length; i++) {
            excellist.push(ws[i]);
          } // At this point, you get an array containing objects that need to be processed
          this.excellist = excellist;
          this.excellist.map((element) => {
            const quantity = element['Số lượng'] ? element['Số lượng'] : 0;
            const discountAmount = element['Chiết khấu']
              ? element['Chiết khấu']
              : 0;
            const unitPrice = element['Đơn giá'] ? element['Đơn giá'] : 0;
            const totalAmount = quantity * unitPrice - discountAmount;

            const data = {
              productName: element['Tên sản phẩm']
                ? element['Tên sản phẩm']
                : '',
              productCode: element['Mã sản phẩm'] ? element['Mã sản phẩm'] : '',
              productImei: element['IMEI'] ? element['IMEI'] : '',
              unitPrice: unitPrice,
              quantity: quantity,
              discountAmount: discountAmount,
              totalAmount: totalAmount,
            };
            this.importItems.push(data);
          });
        } catch (e) {
          return alert('Read failure!');
        }
      };
      fileReader.readAsBinaryString(files);
    },
    clearFiles() {
      this.$refs['file-input'].reset();
    },
    showModal: function () {
      this.importItems = [];
      this.excellist = [];
      this.$refs['import-product-modal'].show();
    },
    hideModalImportProduct() {
      this.$refs['import-product-modal'].hide();
    },
    validData: async function () {
      const data = {
        listData: this.importItems,
        storeId: this.storeId,
        type: this.type,
      };

      await ApiService.post('stock-slips/valid-data-import', data)
        .then((response) => {
          const { status, message } = response.data;
          if (status === 1) {
            makeToastSuccess(message);
            response.data.data.forEach((element) => {
              const item = {
                id: v4(),
                productName: element.productName,
                productCode: element.productCode,
                barCode: element.barCode,
                totalQuantityInStock: element.totalQuantityInStock,
                imeiCode: element.imeiCode
                  .replace(/[,]/g, '\n')
                  .replace(/[ ]/g, ''),
                productId: element.productId,
                unitPrice: element.unitPrice,
                quantity: element.quantity,
                discountAmount: element.discountAmount,
                totalAmount: element.totalAmount,
                productType: element.productType,
              };
              this.listResult.unshift(item);
            });
            this.hideModalImportProduct();
            this.$emit('validData', this.listResult);
          } else {
            makeToastFaile(message);
          }
        })
        .catch((err) => {
          makeToastFaile(err);
        });
    },
    convertPrice(number) {
      return convertPrice(number);
    },
  },
};
</script>